//
// settings is an object that describes how the content searcher should function.
//
// defaultParams.	array. the default parameters used for a search.
//
var ContentSearcher = function (settings) {
    
	this.settings = settings;
	this.currentProvider;
    this.currentTimeframe = 'month';
    this.$dateFrom;
    this.$dateTo;

	// a lookup from search parameter (server side) to display parameter (ui)
	this.displayNames = {
		'businessunit': 'Business Unit',
		'month': 'This Month',
		'today': 'Today',
		'week': 'This Week',
		'months-eighteen' : '18 Months',
		'wfa': 'Wells Fargo Advisors',
		'wfii': 'Wells Fargo Investment Institute',
		'wfs': 'Wells Fargo Securities',
		'consensus': 'Refinitiv',
		'morningstar': 'Morningstar'
	};
};

//
// init the content searcher, bind events ot the dom and draw the default parametes in
// the search ui
//
ContentSearcher.prototype.init = function () {	
	this.drawDefaultParams();
    this.initializeSelectmenus();
    this.initializeDatepickers();
    this.bindEvents();
};

//
// bind events ot the dom
//
ContentSearcher.prototype.bindEvents = function () {

	$('#search-form').on(
		'change.mk-selectmenu',
		$.proxy(this.handleMenuChange, this)
	);

	$('#search-form').on(
		'submit',
		$.proxy(this.handleSubmit, this)
	);

	$('#tag-list').on(
		'click',
		'.icon-close',
		$.proxy(this.handleRemoveFilterClick, this)
    );

	if (this.$dateFrom && this.$dateTo) {
		this.$dateFrom.on(
			'change',
			$.proxy(this.HandleDatepickerChange, this)
		);

		this.$dateTo.on(
			'change',
			$.proxy(this.HandleDatepickerChange, this)
		);
	}
};

ContentSearcher.prototype.initializeSelectmenus = function() {
	var $menus = $('.container').find('.mk-sm-root');
	
	for (var i = 0; i < $menus.length; i++) {
		this.bindMenuInstance($($menus[i]));
	}

	var provider = this.settings.defaultParams.find(function(element) { return element.name == 'provider'; });
	if (provider) {
		this.currentProvider = provider.value;
		$("#timeframe-select option:selected").val('month');
	    this.HandleEighteenMonthsOption(provider.value);
	}
};

ContentSearcher.prototype.initializeDatepickers = function () {
	var Datepicker = Mk.get('Datepicker');

	if ($('#search-form').find('#filter-date-from').length === 0 || $('#search-form').find('#filter-date-to').length === 0) {
		return;
	}
    this.$dateFrom = new Datepicker($('#search-form').find('#filter-date-from').parents('.mk-dp-root'));
    this.$dateTo = new Datepicker($('#search-form').find('#filter-date-to').parents('.mk-dp-root'));

    // Fix dateTo css position
    $('#search-form').find('#filter-date-to').siblings('.mk-dp-shadow').find('.mk-dp-calendar.popup').attr('style', 'left: -160px');

    // Set the custom timeframe to 90 days as a default
    var today = new Date()
    var threeMonthsAgo = new Date();

    threeMonthsAgo.setDate(today.getDate() - 90);

    this.$dateTo.setDate(today);
    this.$dateFrom.setDate(threeMonthsAgo);
    this.$dateFrom.update();
}

ContentSearcher.prototype.bindMenuInstance = function ($el) {
	var mkSelectmenuInstance = new Mk.Selectmenu($el);

	// add mkselectmenuInstance to the element's data
	$el.data('instance', mkSelectmenuInstance);
	mkSelectmenuInstance.on('change', $.proxy(this.handleMenuChange, this, $el));
};

//
// draws the tags for the the default parameters
//
ContentSearcher.prototype.drawDefaultParams = function() {
    
	var defaultParams = this.settings['defaultParams'];

	// there are no default parameters
	if (defaultParams.length === 0) {
		return;
	}

	// for each parameter, add a filter to the UI
	for (var i = 0; i < defaultParams.length; i++) {
		var param = defaultParams[i];
		// Split param value in case of multiple pipe delimited params
		if (param && param['value'] && param['value'].indexOf('|') > -1) {
			var params = param['value'].split('|');
			var paramsLength = params.length;

			for (var j = 0; j < paramsLength; j++) {
				this.addFilter(param['name'], params[j], param['required'], true);
			}
		} else {
            //If param['value']doesn't contains a pipe, It must be used like one only string
		    if (param && param['value'] && param['value'].constructor === Array)
		    {
		        param['value'] = param['value'][0];
		    }
			this.addFilter(param['name'], param['value'], param['required'], false);
		}
	}

	return;
};

//
// retrieves the search parameters from the search form
//
ContentSearcher.prototype.getSearchParameters = function () {
    var $filters = $('#tag-list').find('span.tag');
	var searchFilters = {};

	for (var i = 0; i < $filters.length; i++) {
		var $filter = $($filters[i]);
		var filterType = $filter.data('filtertype');
		var filterValue = $filter.data('filtervalue');
		var multiples = $filter.data('multiples');

		if (!filtersValid(filterType, filterValue)) {
			continue;
		}

		// the search filter already has the filter value added
		if (_.has(searchFilters, filterType) && multiples) {
			searchFilters[filterType] += ('|' + filterValue);
			continue;
		}

	    // add the filter type to the search filters object
        searchFilters[filterType] = filterValue;

        if (filterType === "timeframe" && filterValue === "custom") {
            var fromDate = this.$dateFrom.date.toISOString();
            var toDate = this.$dateTo.date.toISOString();

            var fromDateParts = fromDate.split('T');
            var toDateParts = toDate.split('T');

            searchFilters["startDate"] = fromDateParts[0];
            searchFilters["endDate"] = toDateParts[0];
        }
	}

	return searchFilters;
};

//
// gets the search parameters, and emits an f2 event with those parameters
// anyone looking for that F2 event will update their search results
//
ContentSearcher.prototype.updateSearchResults = function () {
	var params = this.getSearchParameters();
	return F2.Events.emit('UPDATE_RESULTS', params);
};

//
// handles a dropdown menu change and adds the tag to the UI
// param : $el > $('.mk-sm-root');
//
ContentSearcher.prototype.handleMenuChange = function ($el) {
    if ($el instanceof jQuery === false) {
        return;
    }

    var $select = $el.find('.mk-sm');

	var filterType = $select.attr('name');
	var filterValue = $select.val();

	if (filterType === "provider") {
		this.currentProvider = filterValue;
	}

	if (_.isUndefined(filterType)) {
		return;
	}

	var required = $select.data('required'); // the field is required for searching
	var multiples = $select.data('multiples'); // a user is able to pick multiples of this dropdown

	// check if we need to add/remove 18 months option
	if (filterType === 'provider' && getModule().toLowerCase() === "research") {
		this.HandleEighteenMonthsOption(filterValue);
	}

	// this deals with multi-select dropdowns
	//	we want to create a filter for each value
	//	these dropdowns will pass filterValue as an array of strings
	if (filterValue && filterValue.constructor === Array) {
		
		this.removeFilter(filterType, false);
		
	    for (var i = 0; i < filterValue.length; i++) {
			// since we are looping through and adding filters for each selection in a dropdown,
	        //	we don't want to updateSearchResults() at the end of .addFilter(), so we pass true for 'fromMultiSelectDropdown'
	        this.addFilter(filterType, filterValue[i], required, multiples, true);
	    }
	} else {
	    this.addFilter(filterType, filterValue, required, multiples);
	}
	
	if (filterType === "provider") {
		this.currentProvider = filterValue;
    }

    if (filterType === "timeframe") {
        this.currentTimeframe = filterValue;

        if (filterValue === "custom") {
            $(".custom-date-filter-container").removeClass("hide");
        } else {
            $(".custom-date-filter-container").addClass("hide");
        }

        if (!this.ValidateDates()) {
            return;
        }
	}

    this.updateSearchResults();

	return;
};

ContentSearcher.prototype.HandleDatepickerChange = function () {
    if (this.ValidateDates()) {
        this.updateSearchResults();
    }    

    return;
}

ContentSearcher.prototype.ValidateDates = function () {
    if (this.$dateFrom.date > this.$dateTo.date) {
        $(".custom-date-filter-container .custom-date-filter-error").removeClass("hide");

        return false;
    } else {
        $(".custom-date-filter-container .custom-date-filter-error").addClass("hide");

        return true;
    }
}

ContentSearcher.prototype.HandleEighteenMonthsOption = function (provider) {
	var $eighteenMonths = $('option[value="months-eighteen"]');
	var $li = $eighteenMonths.parent();
	
	var $select = $('#timeframe-select');
	var optionElementEighteenMonths = '<option value="months-eighteen">The Past 18 Months</option>';
	var anchorElementEighteenMonths = $("[data-value='months-eighteen']");
	var listElement = $("#timeframe-select ~ div").find('.mk-sm-list').children().last().children();
	var listsmOption = anchorElementEighteenMonths.parent().parent().children().children();

	var $month = $('[data-value="month"]');
	var $input = $('input[aria-label^="timeframe"]');
	var idxSelected = $('#timeframe-select option[value="'+this.currentTimeframe+'"]').index();
    if (provider == 'wfs') {
		for(var i = 0; i < listsmOption.length ; i++){
			listsmOption[i].setAttribute("aria-selected","false");
		}
		//Rebuild the timefame filter tags
		if(listsmOption.length !== 0 ) {
			listsmOption[idxSelected].setAttribute("aria-selected","true");
		}
        if ($eighteenMonths.attr("aria-selected") === 'true')
        {
			$eighteenMonths.attr("aria-selected", "false");
			$input.val("This Month");
			this.resetTimeframe($month, $input, $select);
		}
		if (listElement.attr("aria-selected") === 'true')
		{
			listElement.attr("aria-selected","false");
			$input.val("This Month");
			this.resetTimeframe($month, $input, $select);
		}
		if($input.val() === "The Past 18 Months") {
			$input.val("This Month");
			this.resetTimeframe($month, $input, $select);
		}

		if(anchorElementEighteenMonths){
			anchorElementEighteenMonths.hide();
		}
		
		listElement.hide();
		$eighteenMonths.hide();
		$eighteenMonths.remove();

		listElement.attr("aria-disabled","true");
		
		$li.attr('hidden', 'hidden');
		
    }
    else if (!provider || provider.toString().match(/morningstar/)) {
		if(anchorElementEighteenMonths){
			anchorElementEighteenMonths.show();
		}
		
		$eighteenMonths.remove();
		listElement.show();
		listElement.attr("aria-disabled","false");
		$li.removeAttr('hidden', 'hidden');
		$selectDropdown = $('#timeframe-select');
		$selectDropdown.append(optionElementEighteenMonths);
		$selectDropdown[0].options.selectedIndex = idxSelected;
    }
}

/**
 * Reset timeframe option to default
 *
 * @param {jQuery a} timeframe
 * @param {jQuery input} input
 * @param {jQuery select} select
 */
ContentSearcher.prototype.resetTimeframe = function (timeframe, input, select) {
	var defaultTimeframeValue = this.settings.defaultParams.find(function(element) { return element.name === 'timeframe' });

	timeframe.attr("aria-selected", "true");
	input.val(timeframe.find('.mk-sm-label').text());
	input.attr("aria-activedescendant", timeframe.attr("id"));
	select.val(timeframe.attr("data-value"));

	if (defaultTimeframeValue) {
		select.val(defaultTimeframeValue.value);
	
		this.currentTimeframe = defaultTimeframeValue.value
		this.updateTag('timeframe', defaultTimeframeValue.value, true, false);
	}
}

//
// handle the form submit (hitting enter or clicking the magnify glass)
//
ContentSearcher.prototype.handleSubmit = function (evt) {
    
	evt.preventDefault();
	var term = $('#term').val();
	var multiplesAllowed = $(evt.target).find('input').data('multiples');

	if (_.isUndefined(term)) {
		return;
	}

	this.addFilter('term', term, false, multiplesAllowed);
	this.updateSearchResults();
	$('#term').val('');
	return;
};

//
// adds a filter to the UI and preforms the search
//
//	had to drop the parameters down a line to satisfy gulp quality - SORRY
//
ContentSearcher.prototype.addFilter = function(filterType, filterValue, required, multiplesAllowed, fromMultiSelectDropdown) {
	
	// passing nothing for filterValue means nothing is selected, so we remove all filters of that type and update the table
	if (filterValue === null) {

		this.removeFilter(filterType, false);
		this.updateSearchResults();
		return;
	}

	// are multiples of the same tags allowed? typically used for "or" searches
	multiplesAllowed = _.isUndefined(multiplesAllowed) ? false : multiplesAllowed;

	// if they are, remove any filter for that filter type.
	if (!multiplesAllowed) {
		this.removeFilter(filterType, false);
	}

	// if the filter value is undefined or null, just update the results
	if (_.isUndefined(filterValue) || filterValue === '') {
		return this.updateSearchResults();
	}

	// if the filter type is page, just update the results since no tag is necessary
	if (filterType == 'page') {
		return this.updateSearchResults();
	}

	this.updateTag(filterType, filterValue, required, multiplesAllowed);
	// if we are adding filters for a multi-select dropdown, we don't want to updateSearchResults() for each filter created
	//	the only time fromMultiSelectDropdown will resolve to true is when .addFilter() is called from the loop in .handleMenuChange()
	//	all other cases, we want to updateSerchResults() when we add the filter
	if (fromMultiSelectDropdown) {
		return;
	}

	return this.updateSearchResults();
};

/**
 * update UI tag
 *
 * @param {string} filterType
 * @param {string} filterValue
 * @param {boolean} required
 * @param {boolean} multiplesAllowed
 */
ContentSearcher.prototype.updateTag = function(filterType, filterValue, required, multiplesAllowed) {
	if (!multiplesAllowed) {
		this.removeTag(filterType);
	}
	
	this.addTag(filterType, filterValue, required, multiplesAllowed)
}

/**
 * add UI tag
 *
 * @param {string} filterType
 * @param {string} filterValue
 * @param {boolean} required
 * @param {boolean} multiplesAllowed
 */
ContentSearcher.prototype.addTag = function(filterType, filterValue, required, multiplesAllowed) {
	// this is silly, but breaks gulp quality for being too long
	var opening = [
		'<span class="tag" ',
			'data-filtertype="{filterType}" ',
			'data-filtervalue="{filterValue}" ',
			'data-multiples="{multiples}" ',
			'style="margin-right: 15px;"',
		'>'
	].join('');

	// the html for the tag box
	var tag = [
		opening,
			'<span>{displayFilterType}: {displayFilterValue}</span>',
			'{removeIcon}',
		'</span>'
	].join('');

	// lookup display filter names (these are defined at the top of the file)
	// some names we want to display a different value than what is passed to the server
	var displayFilterType = this.getDisplayName(filterType);
	var displayFilterValue = this.getDisplayName(filterValue);

	var removeIconHtml = [
		'<a href="javascript: void(0);" class="icon icon-close mk-filter-chip-close-button" role="button">',
			'<span class="sr-only">remove filter for {filterType}</span>',
			'<span class="sr-only">value currently selected: {displayFilterValue}</span>',
		'</a>'
	].join('');

	// add the html created above to the tag list on the page
	$('#tag-list').append(
		tag.supplant({
			displayFilterType: displayFilterType,
			displayFilterValue: displayFilterValue,
			// If filterValue is an array, we need to join into a pipe delimited string
			filterValue: filterValue && filterValue.constructor === Array
				? filterValue.join('|')
				: filterValue,
			filterType: filterType,
			multiples: multiplesAllowed ? 'true' : 'false',
			removeIcon: required
				? ''
				: removeIconHtml.supplant({
					filterType: filterType,
					displayFilterValue: displayFilterValue
				})
		})
	);

	// ensure we can see the tag list
	$('#tags').show();
}

/**
 * remove UI tag
 *
 * @param {string} filterType
 */
ContentSearcher.prototype.removeTag = function(filterType) {
	$('#tag-list').find('span[data-filterType="' + filterType + '"]').remove();
}
//
// removes a filter from the UI and preforms a search
//
ContentSearcher.prototype.removeFilter = function(filterType, updateResults) {
    
	updateResults = _.isUndefined(updateResults) ? false : updateResults;

	$('#tag-list').find('span[data-filterType="' + filterType + '"]').remove();

	if (updateResults) {
		this.updateSearchResults();
	}
};

//
// handles the click on the (x) icon in a tag
//
ContentSearcher.prototype.handleRemoveFilterClick = function (evt) {
    
    evt.preventDefault();
    var $tag = $(evt.target).closest('.tag');
    var filtertype = $tag.attr('data-filtertype');

    $tag.remove();

    if ($('#tag-list').find('.tag').length === 0) {
        $('#tags').hide();
    }

    this.handleUpdateFilter(evt);

    var provider = this.getSearchParameters().provider;

    if (filtertype === 'provider' && getModule().toLowerCase() === "research") {
        this.HandleEighteenMonthsOption(provider);
    }

	return this.updateSearchResults();
};

//
// updates the filter (for multiple selection dropdowns)
//
//	should only do anything if the filterType leads to a multi-select dropdown
//
ContentSearcher.prototype.handleUpdateFilter = function (evt) {
    
	evt.preventDefault();

	var filterType = $(evt.target).parents().data('filtertype');
	var filterValue = $(evt.target).parents().data('filtervalue');
	var $dropdown = $('#search-form').find('[data-filtertype="' + filterType + '"]');

	if ($dropdown.length > 0) {

		$dropdown.find('[value="' + filterValue + '"]').removeAttr('selected');
		$dropdown.closest('.mk-sm-root').data('instance').update();
	}

	return;
};

//
// get the display (friendly ui) name for a filter (sql/recon) value
//
ContentSearcher.prototype.getDisplayName = function(originalName) {
    
	if (_.isUndefined(originalName) || originalName === null || originalName === '') {
		return '--';
	}

	//// handle case where originalName is passed as an array here (multiple selections)
	//if (originalName.constructor === Array) {
	//	var arr = originalName;
	//	var displayArr = [];

	//	for (var i = 0; i < arr.length; i++) {

	//		var current = arr[i];

	//		displayArr.push(this.displayNames[current]);
	//	}

	//	return displayArr.join(', ');
	//}
	// ReSharper disable once QualifiedExpressionMaybeNull
	var lowerCased = originalName.toLowerCase();

	return _.has(this.displayNames, lowerCased)
		? this.displayNames[lowerCased]
		: toTitleCase(originalName);
};

/**
 * returns module name string for 18 months validity check
 *
 * @returns {string}
 */
function getModule() {
	return $('#ratings-search .nav .active').text().trim(); // find the active module
}

//
// title case a string
//
function toTitleCase(str) {
    
	return str.replace(
		/\w\S*/g,
		function(txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		}
	);
}

//
// ensure the filter has a type and a value
//
function filtersValid(filterType, filterValue) {
    
	if (
		_.isUndefined(filterType) || filterType === '' ||
		_.isUndefined(filterValue) || filterValue === ''
	) {
		return false;
	}

	return true;
}
